module.exports = __webpack_public_path__ + "static/media/p3.955a654a.png";